import * as HydraNavState from '@customerio/hydra-nav-state';
import * as HydraPlumaState from '@customerio/hydra-pluma-state';
import { featureFlagDevToolsForEnv } from '@/services/dev-helper/feature-flags';
import { isHydraRoute } from '@/services/router/route-ownership';
import { accountStore } from '@/services/auth/store';
import * as HydraSessionState from '@customerio/hydra-session-state';
import { session } from '@/services/session';
import { billing } from '@/services/billing';
import { rumEmbeddedBridge } from '@/services/rum';
import { sentryCaptureException } from '@/utils/sentry';

export default function injectGlobals() {
  // `Session#initialize()` rejects with the underlying error after exhausting
  // its network retries (or for any non-network failure). Surface it to Sentry
  // so we can see auth-bootstrap failures in production.
  void session.initialized.catch((error) => {
    sentryCaptureException(error);
  });

  Object.assign(window, {
    HydraNavState,
    HydraPlumaState,
    HydraSessionState,
    // Expose routing utilities for Ember to check if a URL belongs to Hydra.
    // Ember asks per navigation (always after the account has loaded), so a
    // call-time account snapshot is correct here.
    __hydra__: {
      ...window.__hydra__,
      isHydraRoute: (path: string) => isHydraRoute(path, accountStore.get()),
      session,
      billing,
      // Capability flag: this shell shows its own in-place re-auth modal on
      // session rejection. Embedded apps check it to delegate their 401
      // handling (announceRefreshAuth) instead of opening their own modal.
      reauthModal: true,
      // RUM bridge: embedded apps report load milestones (e.g. Journeys'
      // "loading state ended") into the shell's beacon session.
      rum: rumEmbeddedBridge,
      // Local-only: scriptable feature-flag control for callers that can only
      // reach the page through the console. Absent outside dev environments.
      ...featureFlagDevToolsForEnv(),
    },
  });
}
